module.exports = __webpack_public_path__ + "img/phone-operator@1x.d81ba708.png";